export const DISABLED_FILTER_MESSAGE =
  "This filter cannot refine the current selection further.";
